import Markdown from 'markdown-to-jsx'

import Icon from '../icons/Icon'

type RoundedNoteProps = {
  readonly content: {
    content: string
    ButtonLink: {
      text: string
      style: string
      link: string
      withArrow: boolean
    }
  }
}

const RoundedNote: React.FC<RoundedNoteProps> = ({ content }) => {
  return (
    <div className="mt-12 tablet:py-6">
      <div className="flex flex-col items-center justify-center rounded-full border-2 border-solid border-white p-6 tablet:flex-row">
        <Markdown className="text-md mb-4 text-center tablet:m-0">{content.content}</Markdown>
        {content.ButtonLink && (
          <a className="color-primary pl-3 text-base font-bold uppercase" href={content.ButtonLink.link}>
            {content.ButtonLink.text}
            {content.ButtonLink.withArrow && <Icon icon="arrow" size="xs" className="ml-4" />}
          </a>
        )}
      </div>
    </div>
  )
}

export default RoundedNote
